import React, { useEffect } from "react";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Newsletter from "../components/Newsletter";
import Breadcrumbs from "../components/Breadcrumbs";
import { getTranslatedPath } from "../utils/languageUtils";

export default function Terms({ setHeader }) {
  const { t, i18n } = useTranslation();
  const currentPaths = getTranslatedPath(i18n.language);
  const alternateLinks = [
    { hrefLang: "en", href: getTranslatedPath("en")["terms-of-use"] },
    { hrefLang: "sr", href: getTranslatedPath("sr")["terms-of-use"] },
  ];
  const metaDescription = t("header.privacy.metaDescription").trim()
    ? t("header.privacy.metaDescription")
    : t("header.home.metaDescription");
  const breadcrumbs = [
    { name: t("header.home.menuTitle"), url: `/${i18n.language}` },
    { name: t("termsAndConditions.title"), url: currentPaths["terms-of-use"] },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  return (
    <>
      <Seo
        title={t("termsAndConditions.title")}
        description={metaDescription}
        path={currentPaths["terms-of-use"]}
        alternateLinks={alternateLinks}
        breadcrumbs={breadcrumbs}
      />
      <Loader />
      {/* <!-- Main content Start --> */}
      <div className="main-content">
        {/* <!-- Breadcrumbs Start --> */}
        <div className="rs-breadcrumbs img3">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("termsAndConditions.title")}
                {/*<span className="watermark">{privacy.title}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs bg="light" />
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- Faq Section Start --> */}
        <div className="rs-faq gray-bg4 pt-120 md-pt-80">
          <div className="container">
            {/* <!-- Privacy policy Section Start --> */}
            <div className="rs-privacy-policy pt-10 md-pt-80">
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">{t("termsAndConditions.sections.introduction.title")}</h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.introduction.content")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                  {t("termsAndConditions.sections.privacyStatement.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.privacyStatement.content")}</p>
                  <p>{t("termsAndConditions.sections.dataProtection.content")}</p>
                  <p>{t("termsAndConditions.sections.userRegistration.content")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.productDescription.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.productDescription.content")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.productPrices.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.productPrices.content")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.shippingCosts.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.shippingCosts.content")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.packaging.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.packaging.content")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.paymentMethods.title_1")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.paymentMethods.content_1")}</p>
                  <h3>{t("termsAndConditions.sections.paymentMethods.title_2")}</h3>
                  <p>{t("termsAndConditions.sections.paymentMethods.content_2")}</p>
                  <h3>{t("termsAndConditions.sections.paymentMethods.title_3")}</h3>
                  <p>{t("termsAndConditions.sections.paymentMethods.content_3")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.reclamation.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.reclamation.content_1")}</p>
                  <p>{t("termsAndConditions.sections.reclamation.content_2")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.payback.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.payback.content_1")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.returns.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.returns.content_1")}</p>
                  <p>{t("termsAndConditions.sections.returns.content_2")}</p>
                  <ul className="check-list">
                    <li>{t("termsAndConditions.sections.returns.reason_1")}</li>
                    <li>{t("termsAndConditions.sections.returns.reason_2")}</li>
                    <li>{t("termsAndConditions.sections.returns.reason_3")}</li>
                    <li>{t("termsAndConditions.sections.returns.reason_4")}</li>
                    <li>{t("termsAndConditions.sections.returns.reason_5")}</li>
                    <li>{t("termsAndConditions.sections.returns.reason_6")}</li>
                    <li>{t("termsAndConditions.sections.returns.reason_7")}</li>
                  </ul>
                  <p>{t("termsAndConditions.sections.returns.content_3")}</p>
                  <p>{t("termsAndConditions.sections.returns.content_4")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.changeOfTerms.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p>{t("termsAndConditions.sections.changeOfTerms.content_1")}</p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.companyInfo.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p><span className="bold">{t("termsAndConditions.sections.companyInfo.content_1")}</span>
                    <br/>{t("termsAndConditions.sections.companyInfo.content_2")}
                    <br/>{t("termsAndConditions.sections.companyInfo.content_3")}
                    <br/>{t("termsAndConditions.sections.companyInfo.content_4")}
                    <br/>{t("termsAndConditions.sections.companyInfo.content_5")}
                    <br/>{t("termsAndConditions.sections.companyInfo.content_6")}
                    <br/>{t("termsAndConditions.sections.companyInfo.content_7")}
                    <br/>{t("termsAndConditions.sections.companyInfo.content_8")}
                    <br/>{t("termsAndConditions.sections.companyInfo.content_9")}
                  </p>
                </div>
              </div>
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("termsAndConditions.sections.customerService.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <p><span className="bold">{t("termsAndConditions.sections.customerService.content_1")}</span>
                    <br/>{t("termsAndConditions.sections.customerService.content_2")}
                    <br/>{t("termsAndConditions.sections.customerService.content_3")}
                    <br/>{t("termsAndConditions.sections.customerService.content_4")}
                  </p>
                </div>
              </div>
            </div>
            {/* <!-- Privacy policy Section End -->    */}
          </div>
          {/* <!-- Newsletter section start --> */}
          <div className="rs-newsletter style1 pt-90 md-pt-60 mb--65">
            <Newsletter />
          </div>
          {/* <!-- Newsletter section end --> */}
        </div>
        {/* <!-- Faq Section End --> */}
      </div>
      {/* <!-- Main content End --> */}
    </>
  );
}
